import type { CreateAxiosDefaults } from 'axios';
import type { IAxiosRetryConfig } from 'axios-retry';
import { stringify } from 'qs';
import { isHttpSuccess } from './shared';
import type { RequestOption } from './type';

export function createDefaultOptions<ResponseData = any>(options?: Partial<RequestOption<ResponseData>>) {
  const opts: RequestOption<ResponseData> = {
    onRequest: async config => config,
    isBackendSuccess: _response => true,
    onBackendFail: async () => {},
    transformBackendResponse: async response => response.data,
    onError: async () => {}
  };

  Object.assign(opts, options);

  return opts;
}

export function createRetryOptions(config?: Partial<CreateAxiosDefaults>) {
  // Default to no automatic retries. Retries previously defaulted to 1 (and effectively
  // fell back to axios-retry's own default with exponential backoff) because the
  // consumer-provided `axios-retry` settings were never promoted to the top-level
  // `IAxiosRetryConfig`. That caused user-initiated mutations (create/edit) to be retried
  // multiple times on failure.
  const retryConfig: IAxiosRetryConfig = {
    retries: 0
  };

  // The axios instance config carries retry settings under a nested `axios-retry` key.
  // Promote those settings to the top-level retry config so they are actually applied.
  const nestedRetryConfig = (config as { 'axios-retry'?: IAxiosRetryConfig } | undefined)?.[
    'axios-retry'
  ];

  if (nestedRetryConfig) {
    Object.assign(retryConfig, nestedRetryConfig);
  }

  return retryConfig;
}

export function createAxiosConfig(config?: Partial<CreateAxiosDefaults>) {

  const axiosConfig: CreateAxiosDefaults = {
    headers: {
      'Content-Type': 'application/json'
    },
    validateStatus: isHttpSuccess,
    paramsSerializer: params => {
      return stringify(params);
    }
  };

  Object.assign(axiosConfig, config);

  return axiosConfig;
}
